module.exports = __webpack_public_path__ + "img/ico_heart.7969a3cf.svg";